/**
 * shuttleStops.js — 셔틀버스 정류장 위치 데이터
 *
 * type: 'campus'        — 교내 정류장
 * type: 'external'      — 교외 정류장 (학교 ↔ 외부 역)
 * mapVisible: false     — 지도 마커 생성 안 함 (좌표 참조 전용)
 * needsVerification     — 좌표 공식 미확인
 * needsGeocoding        — 주소는 있으나 좌표 미확보
 *
 * role: 정류장 성격 — 상세 시트 배지 표시에 사용 (type만으로는 구분 불가)
 *   'campus_loop'       — 교내 순환 셔틀 정류장 (탑승/하차)
 *   'hagyo_departure'   — 하교 셔틀 출발 정류장 (예: 송내역·병점역 하교)
 *   'external'          — 외부역 셔틀 승차장
 */

export const SHUTTLE_STOPS = {
  /* ─── 교내 ─────────────────────────────────────────────── */

  'campus-inmundae': {
    id: 'campus-inmundae',
    name: '인문대 승차',
    type: 'campus',
    role: 'campus_loop',
    lat: 37.213019,
    lng: 126.978107,
    description: '인문사회관 앞 셔틀버스 탑승 위치',
    detail: '사당역·병점역 방면 출발 / 교내 순환 셔틀 출발 위치',
    needsVerification: false,
    icon: '🚌',
    buildingId: 'humanities',
  },
  'campus-hum-exit': {
    id: 'campus-hum-exit',
    name: '인문대 하차',
    type: 'campus',
    role: 'campus_loop',
    lat: 37.213490,
    lng: 126.978482,
    description: '인문사회관 앞 셔틀버스 하차 위치',
    detail: '',
    needsVerification: false,
    icon: '🚌',
    buildingId: 'humanities',
  },
  'campus-sh': {
    id: 'campus-sh',
    name: '학생회관 사거리',
    type: 'campus',
    role: 'campus_loop',
    lat: 37.210081,
    lng: 126.97701,
    description: '학생회관 사거리 셔틀버스 정류소',
    detail: '외부 노선 도착 정류소',
    needsVerification: false,
    icon: '🚌',
    buildingId: 'student-hall',
  },
  'campus-ict': {
    id: 'campus-ict',
    name: 'ICT융합대학',
    type: 'campus',
    role: 'campus_loop',
    lat: 37.209608,
    lng: 126.975483,
    description: 'ICT융합대학 앞 셔틀버스 정류소',
    detail: '',
    needsVerification: false,
    icon: '🚌',
    buildingId: 'it-building',
  },
  'campus-music': {
    id: 'campus-music',
    name: '음악대학',
    type: 'campus',
    role: 'campus_loop',
    lat: 37.209872,
    lng: 126.972801,
    description: '음악대학 앞 셔틀버스 정류소',
    detail: '',
    needsVerification: false,
    icon: '🚌',
    buildingId: null,
  },
  'campus-art': {
    id: 'campus-art',
    name: '미술대학/조형관',
    type: 'campus',
    role: 'campus_loop',
    lat: 37.207798,
    lng: 126.977988,
    description: '미술대학 및 조형관 앞 셔틀버스 정류소',
    detail: '',
    needsVerification: false,
    icon: '🚌',
    buildingId: null,
  },
  'campus-backgate': {
    id: 'campus-backgate',
    name: '후문/제4공학관',
    type: 'campus',
    role: 'campus_loop',
    lat: 37.206881,
    lng: 126.979861,
    description: '후문 및 제4공학관 앞 셔틀버스 정류소',
    detail: '',
    needsVerification: false,
    icon: '🚌',
    buildingId: null,
  },
  'campus-eng1': {
    id: 'campus-eng1',
    name: '제1공학관',
    type: 'campus',
    role: 'campus_loop',
    lat: 37.209096,
    lng: 126.979252,
    description: '제1공학관 앞 셔틀버스 정류소',
    detail: '',
    needsVerification: false,
    icon: '🚌',
    buildingId: null,
  },
  'campus-byeongjeom-hagyo': {
    id: 'campus-byeongjeom-hagyo',
    name: '병점역 하교 셔틀 승차장',
    type: 'campus',
    role: 'hagyo_departure',
    lat: 37.212787,
    lng: 126.978226,
    description: '병점역행 하교 셔틀버스 승차 정류장',
    detail: '인문대 인근 · 병점역 방면 하교(16:40) 셔틀 승차장',
    needsVerification: false,
    icon: '🚌',
    buildingId: 'humanities',
    routeGroup: '병점역 노선',
    direction: '하교',
    aliases: ['병점역 하교', '병점 하교', '병점 하교 셔틀', '병점역 하교 셔틀', '병점역 하교 승차장', '병점역 하교 셔틀 승차장'],
    relatedStationId: 'byeongjeom',
  },
  'campus-songnae-hagyo': {
    id: 'campus-songnae-hagyo',
    name: '송내역 하교',
    type: 'campus',
    role: 'hagyo_departure',
    lat: 37.213873,
    lng: 126.978721,
    description: '송내역행 하교 셔틀버스 정류장',
    detail: '학교 → 송내역 하교 셔틀 출발 정류장',
    needsVerification: false,
    buildingId: null,
    routeGroup: '송내역 노선',
    direction: '하교',
    aliases: ['송내역 하교', '송내 하교', '송내역 하교 셔틀', '송내 하교 셔틀'],
    relatedStationId: 'songnae',
  },

  /* ─── 교외 ─────────────────────────────────────────────── */

  'byeongjeom-station': {
    id: 'byeongjeom-station',
    name: '병점역 셔틀 타는 곳',
    type: 'external',
    role: 'external',
    lat: 37.207061,
    lng: 127.031807,
    description: '병점역 인근 수원대학교 셔틀버스 승차 위치',
    detail: '후문 2번·3번 출구 / 버스정류장 앞 · 전세버스 무료 운행',
    routeGroup: '병점역 노선',
    direction: '학교행',
    needsVerification: false,
    icon: '🚉',
    buildingId: null,
    category: '외부 셔틀',
    aliases: ['병점', '병점 셔틀', '병점역 셔틀', '병점역 승차장'],
    relatedStationId: 'byeongjeom',
  },
  'songnae-station': {
    id: 'songnae-station',
    name: '송내역 셔틀 타는 곳',
    type: 'external',
    role: 'external',
    lat: 37.485332,
    lng: 126.753596,
    description: '송내역 고려한증막 앞 셔틀버스 승차 위치',
    detail: '1번 출구에서 송내지하차도 방향 150m 직진 · 4구역(노면표시 4번) 탑승',
    routeGroup: '송내역 노선',
    direction: '학교행',
    needsVerification: false,
    icon: '🚉',
    buildingId: null,
    category: '외부 셔틀',
    aliases: ['송내', '송내 셔틀', '송내역 셔틀', '송내역 승차장'],
    relatedStationId: 'songnae',
  },
  'gosaek-station': {
    id: 'gosaek-station',
    name: '고색역 셔틀 타는 곳',
    type: 'external',
    role: 'external',
    lat: 37.250887,
    lng: 126.981474,
    address: '경기 수원시 권선구 매송고색로 698',
    description: '고색역 인근 수원대학교 셔틀버스 승차 위치',
    detail: '3번 출구 · 새마을금고 앞 · 전세버스 무료 운행',
    routeGroup: '고색역 노선',
    direction: '학교행',
    needsVerification: false,
    icon: '🚉',
    buildingId: null,
    category: '외부 셔틀',
    aliases: ['고색', '고색 셔틀', '고색역 셔틀', '고색역 승차장'],
    relatedStationId: 'gosaek',
  },
  'gangnam-station': {
    id: 'gangnam-station',
    name: '강남역 셔틀 타는 곳',
    type: 'external',
    role: 'external',
    lat: 37.497303,
    lng: 127.02771,
    description: '강남역 7번 출구 산업은행 앞 셔틀버스 승차 위치',
    detail: '7번 출구에서 산업은행 방향 도보 1분',
    routeGroup: '강남역 노선',
    direction: '학교행',
    needsVerification: false,
    icon: '🚇',
    buildingId: null,
    category: '외부 셔틀',
    aliases: ['강남', '강남 셔틀', '강남역 셔틀', '강남역 승차장'],
    relatedStationId: 'gangnam',
  },
  'sadang-station': {
    id: 'sadang-station',
    name: '사당역 셔틀 타는 곳',
    type: 'external',
    role: 'external',
    lat: 37.472199,
    lng: 126.982639,
    description: '사당역 홈플러스 버스 승차장 앞 셔틀버스 승차 위치',
    detail: '4호선 4번 출구 홈플러스 방향 300m · 2호선 5번 출구 홈플러스 방향 400m',
    routeGroup: '사당역 노선',
    direction: '학교행',
    needsVerification: false,
    icon: '🚇',
    buildingId: null,
    category: '외부 셔틀',
    aliases: ['사당', '사당 셔틀', '사당역 셔틀', '사당역 승차장'],
    relatedStationId: 'sadang',
  },
}
